export default __webpack_public_path__ + "2941c21d765a59c91cdab44553678e80.svg";